import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=c1dce49e&scoped=true&"
import script from "./ModalComment.vue?vue&type=script&lang=js&"
export * from "./ModalComment.vue?vue&type=script&lang=js&"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=c1dce49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dce49e",
  null
  
)

export default component.exports